import React, { useState } from 'react'
import { NavItem } from 'react-bootstrap'
import "./Roadmap.css"
function Roadmap() {
    // const [data, settData] = useState([{
    //     percent: "10%", fall: "Design the bears & trait logic", seven: "Create art",
    //     treasur: "Create marketing plan"
    // },
    // {
    //     percent: "25%", fall: "Community building", seven: "Giveaways & presale preparation",

    // },
    // {
    //     percent: "50%", fall: "Pre-sale", seven: "Public sale",
    //     treasur: "Full launch of the Project"
    // },
    // {
    //     percent: "100%", fall: "Community events", seven: "Start new project utilizing Solarbears",

    // },])

    // const [item, settItem] = useState([{
    //     number: "2021", ques: "Q4", num: "The Sevens rarity data will be added to Rarity, tools as well as Rarity Sniper.",
    //     numu: " Launch of the Sevens online shop for clothes, masks and accesories.", nume: "With the treasure hunt non concluded, work on Season 2 will start.",

    //     numr: "A lot of the projects in the space are fairly siloed. We imagine a future where a lot of NFT projects do collabs ith one another. like many fashion brands in the world. We'll be looking and reaching out to potential collaboration partners."
    // },
    // {
    //     number: "2022", ques: "Q1", num: "Season 2 launch Season 1 holders will have pruarity mining famount 186) as well as sotive community menbers.",
    //     numu: "The Savene ta launch an incubation program working with artists that have a passion for making unique art pieces and fashion attributes. The community treasury will help and future arajects thosen by our comunity.",

    // },
    // {
    //     number: "2022", ques: "Q2", num: "Development and release of The Sevens Do with $SEVEN takar airdropped to all hodlers proportionally.",
    //     numu: "Launch of Season 3.", nume: "The Sevens collection will now be deflationary through a unique mutatio mechanisn.",

    // },
    // ])
    return (
        <>
            <div className="container roads" id="road">
                <div className="road_title">
                    <h1 className="road_titls">Roadmap</h1>
                </div><br />

                {/* boxess */}

                {/* {data.map((dat) => (
                    <div className="boxes">
                        <div className="box1">
                            <div className="box2">
                                <h1 style={{ width: '200px' }} className="text-center">{dat.percent}</h1>
                            </div>
                            <div className="box3">
                                <h3 className="skyfall">{dat.fall}</h3>

                                <h5 className="seven">{dat.seven}</h5>

                                <h5 className="treasury">{dat.treasur}</h5>
                            </div>
                        </div>
                    </div>
                ))}<br /><br /> */}


                <div className="d-flex flex-row road_main">
                    <div>
                        <div className="main_round">
                            <div className="inner_round">

                            </div>



                        </div>
                        <div className="line_div"></div>

                        {/* second */}
                        <div className="main_round">
                            <div className="inner_round">

                            </div>



                        </div>
                        <div className="line_div"></div>
                        {/* third */}
                        <div className="main_round">
                            <div className="inner_round">

                            </div>



                        </div>
                        <div className="line_div"></div>
                        {/* four */}
                        <div className="main_round">
                            <div className="inner_round">

                            </div>
                        </div>

                    </div>
                    <div className="d-flex flex-column ">
                        <div className="ml-5 first_text">
                            <p className="road_p">Solarbears design</p>
                            <p className="road_p">Trait logic design</p>
                            <p className="road_p">Art creation</p>
                            <p className="road_p">Marketing plan creation</p>

                        </div>

                        {/* two */}
                        <div className="ml-5 second_text">
                            <p className="road_p">Community building</p>
                            <p className="road_p">Giveaways & presale preparation</p>

                        </div>

                        {/* three */}
                        <div className="ml-5 third_text">
                            <p className="road_p">Presale</p>
                            <p className="road_p">Public sale</p>
                            <p className="road_p">Full launch of the project</p>

                        </div>

                        {/* four */}
                        <div className="ml-5 four_text">
                            <p className="road_p">Community Events</p>
                            <p className="road_p">Solarbears Metaverse</p>

                        </div>
                    </div>

                </div>

                {/* <div>
                    <h1 className="road_titls tools">Development Roadmap</h1>
                </div> */}

                {/* booxes */}

                {/* 
                {item.map((ite) => (<div className="boxes">
                    <div className="box1">
                        <div className="box2">
                            <h1 style={{ width: '200px' }} className="text-center">{ite.number}</h1>
                        </div>
                        <div className="box3">
                            <h3 className="skyfall">{ite.ques}</h3>

                            <ul>
                                {Object.keys(ite).map((key) => {
                                    if (key != "number" && key != "ques") {
                                        return <li className="skyfalls">{ite[key]}</li>
                                    }
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
                ))} */}
                <br /><br />

            </div>


        </>
    )
}

export default Roadmap
